<script>
    Date.prototype.addDays = function(days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    }
    export let statistic=undefined;
    export let expanded = false;
    //import {apiUrl} from '../config.svelte';
    import {Button,Nav, NavItem, NavLink,Label,Input,FormGroup} from 'sveltestrap';
    import ProjectSelect from '../Components/ProjectSelect.svelte'
    import TeamSelect from './TeamSelect.svelte'
    import {onMount,onDestroy} from 'svelte';
    

    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    let filterBefore=undefined;
    let mnth = ((new Date()).getMonth()+1).toString()
    if(mnth.length==1)mnth="0"+mnth
    let filter={
        date_from:(new Date()).addDays(-1).toJSON().substring(0,10),
        date_to:new Date().toJSON().substring(0,10),
        type_agent:undefined,
        project:undefined,
        year_month:`${(new Date()).getFullYear()}-${mnth}`,
        month:mnth,
        year:(new Date()).getFullYear(),
        project:undefined,
        team:undefined
    }

    function isEmpty(obj) {
		return Object.keys(obj).length === 0;
	}
    
    $:{
        if (filterBefore!=filter){
            if(filter.year_month){
                filter.year=filter.year_month.split("-")[0]
                filter.month=filter.year_month.split("-")[1]
            }
            dispatch('change',{filter:filter})
            filterBefore=filter
        }
    }
    onMount(()=>{
        dispatch('change',{filter:filter})
    })
</script>

{#if !expanded}
    <Button on:click={()=>{if(statistic)expanded=true}} outline color="dark" block style="text-align:left;float:left"><img src="/img/filter-ico2.png" alt="filter" style="width:20px;height:20px;"/>
        {statistic?statistic:""}
    </Button>
{:else}
    <div style="postition:absolute;height:500px;border-radius:4px 4px 4px 4px;box-shadow: 0px 0px 2px black;width:calc(100% - 4px)">
        <Button outline color="dark" style="position:absolute;right:3px;top:3px;" on:click={()=>{expanded=false;}}><img src="/img/min-box.png" style="width:20px;height:20px" alt="скрыть"/></Button>
        <div style="width:400px;height:100%;padding:10px">
            {#if statistic=="по площадкам" || statistic=="Отчет по работе суперов"}
                <div style="float:left;width:300px">
                    <Label for="month-input" style="float:top">месяц и год</Label>
                    <Input type="month" id="month-input" style="float:left;width:200px;" bind:value={filter.year_month} on:change={()=>{console.log(filter.year_month)}}/>
                </div>
            {:else if statistic=="За период по часам" || statistic=="За период по утилизации" || statistic=="За сегодня"}
                <div style="float:left;width:300px">
                    <Label for="date-from-input" style="float:top">от</Label>
                    <Input type="date" id="date-from-input" style="float:left;width:200px;" bind:value={filter.date_from}/>
                </div>
                <div style="float:left;width:300px">
                    <Label for="date-to-input" style="float:top">до</Label>
                    <Input type="date" id="date-to-input" style="float:left;width:200px;" bind:value={filter.date_to}/>
                </div>
                <TeamSelect bind:team={filter.team}/>
            {:else}
                <div style="float:left;width:300px">
                    <Label for="date-from-input" style="float:top">от</Label>
                    <Input type="date" id="date-from-input" style="float:left;width:200px;" bind:value={filter.date_from}/>
                </div>
                <div style="float:left;width:300px">
                    <Label for="date-to-input" style="float:top">до</Label>
                    <Input type="date" id="date-to-input" style="float:left;width:200px;" bind:value={filter.date_to}/>
                </div>      
                <div style="float:left;width:350px">
                    <ProjectSelect bind:project={filter.project}/>  
                </div>
                <div style="float:left;width:350px">
                    <Input type="select" bind:value={filter.type_agent}>
                        <option value={undefined}>Тип агента</option>
                        <option value="HR">HR</option>
                        <option value="Агент">Агент</option>
                    </Input>
                </div>
            {/if}
        </div>
    </div>
{/if}